module.exports = __webpack_public_path__ + "img/kv.6bba93e0.png";